import React, { useState, useEffect, useCallback, useRef } from 'react'
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  Paper,
  useMediaQuery,
  useTheme
} from '@mui/material'
import FilterComponent from '../../../../commonComponents/FilterComponent'
import JobPost from '../../../../commonComponents/JobPost'
import FilterJobFunction from '../../../../commonComponents/FilterJobFunctions'
import { useNavigate } from 'react-router-dom'
import serverData from '../../../../api/ServerData'
import { logoutUser } from '../../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import { TextSemiBold } from '../../../../commonComponents/TextStyling'
import Search from '../../../../commonComponents/Search'
import {
  paddingHorizontal,
  paddingVertical
} from '../../../../utils/AppConstants'
import AppButton from '../../../../commonComponents/AppButton'
import FilterListIcon from '@mui/icons-material/FilterList'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import FilterJobsResponsive from '../../../../commonComponents/ResponsiveComponents/FilterJobsResponsive'

function SearchJob () {
  const theme = useTheme()

  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [previewModal, setPreviewModal] = useState({
    open: false
  })

  const [jobPostData, setJobPostData] = useState([])
  const [dropDownValues, setDorpDownValues] = useState({})

  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const limit = 50
  const filterRef = useRef()

  const [filterItems, setFilterItems] = useState({
    jobTypes: [],
    workLocationType: [],
    jobFunction: [],
    jobIndustry: [],
    // location: [],
    referralReward: []
  })

  useEffect(function () {
    serverData.getJobPostDropDownValues(
      {},
      result => {
        if (result.status) {
          setDorpDownValues(result.response)
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }, [])

  const handleFilterChange = useCallback(updatedFilter => {
    setFilterItems(prevFilter => ({
      ...prevFilter,
      ...updatedFilter
    }))
  }, [])

  useEffect(() => {
    setPage(0)
    searchJobs(0)
  }, [filterItems])

  function searchJobs (page) {
    setLoading(true)
    serverData.getSearchJob(
      { ...filterItems, limit, page },
      result => {
        if (result.status) {
          if (page === 0) {
            setJobPostData(result.response)
          } else {
            setJobPostData(jobPostData.concat(result.response))
          }
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }
  return (
    <Grid
      container
      style={{
        height: `calc(100%)`
      }}
    >
      {matches ? (
        <Grid
          item
          style={{
            position: 'absolute',
            bottom: '5rem',
            left: '1rem',
            zIndex: 1
          }}
        >
          <Paper elevation={3} style={{ borderRadius: '50%', display: 'flex' }}>
            <IconButton
              style={{ padding: '12px' }}
              onClick={() => {
                setPreviewModal({
                  open: true,
                  button: 'addWorklist',
                  ref: filterRef,
                  dropDown: dropDownValues,
                  onFilterChange: handleFilterChange,
                  onClose: () => {
                    setPreviewModal({
                      open: false
                    })
                  }
                })
              }}
            >
              <FilterListIcon style={{ color: theme.palette.primary.main }} />
            </IconButton>
          </Paper>
        </Grid>
      ) : (
        <Grid
          item
          xs={3}
          style={{
            maxHeight: '100%',
            padding: `${paddingVertical} 0px ${paddingVertical} ${paddingHorizontal}`
          }}
        >
          <FilterComponent
            ref={filterRef}
            dropDown={dropDownValues}
            onFilterChange={handleFilterChange}
          />
        </Grid>
      )}
      <Grid
        item
        xs={matches ? 12 : 9}
        style={{
          overflowY: 'auto',
          height: '100%'
        }}
      >
        <Grid
          container
          style={{
            padding: matches
              ? '30px'
              : `${paddingVertical} ${paddingHorizontal} ${paddingVertical} 24px`
          }}
        >
          <Grid item xs={12}>
            <Search
              setOnSearch={(type, search) => {
                handleFilterChange({
                  jobTitle: type === 'title' ? search : '',
                  skillRequired: type === 'title' ? '' : search
                })
              }}
              type={'Jobs'}
            />
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12} style={{ display: 'flex' }}>
                <FilterJobFunction filterRef={filterRef} />
              </Grid>
              <Grid item xs={12} style={{ marginTop: '24px' }}>
                <JobPost
                  data={jobPostData}
                  loading={loading && page === 0}
                  loadingMessage={'Searching for jobs...'}
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                {loading && page !== 0 ? (
                  <CircularProgress />
                ) : (
                  jobPostData.length > 0 &&
                  jobPostData.length % limit === 0 && (
                    <TextSemiBold
                      style={{
                        color: theme.palette.primary.main,
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        searchJobs(page + 1)
                        setPage(page + 1)
                      }}
                    >
                      Click here to load more jobs
                    </TextSemiBold>
                  )
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {previewModal?.open && <FilterJobResponsive data={previewModal} />}
    </Grid>
  )
}

export default SearchJob

const style = {
  position: 'absolute',
  transform: 'translate(-0%, -0%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  width: '100%',
  height: '100%'
  // overflowY: 'auto'
}

function FilterJobResponsive ({ data, matches }) {
  var { open, ref, dropDown, onFilterChange, onClose } = data
  const theme = useTheme()
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <ArrowBackIcon
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 16,
            top: 12,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '32px',
            cursor: 'pointer'
          }}
        />
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FilterJobsResponsive
              ref={ref}
              dropDown={dropDown}
              onFilterChange={onFilterChange}
              matches={matches}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
